import { SpinnerModalComponent } from './../spinner/spinner-modal.component';
import { UntypedFormGroup } from '@angular/forms';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit, Inject } from '@angular/core';
import { ModalAddActiviteComponent } from '../modal-add-activite/modal-add-activite.component';
import { FamilleModel } from 'src/app/shared/models/simple-types/famille.model';
import { FamilleService } from 'src/app/shared/services/simple/famille.service';

export interface DialogData {
  form: UntypedFormGroup;
  familles: FamilleModel[];
  result: boolean;
}

@Component({
  selector: 'app-modal-add-famille',
  templateUrl: './modal-add-famille.component.html',
  styleUrls: ['./modal-add-famille.component.scss']
})
export class ModalAddFamilleComponent implements OnInit {

  form: UntypedFormGroup;
  constructor(public dialog: MatDialog
            , public dialogRef: MatDialogRef<ModalAddActiviteComponent>
            , @Inject(MAT_DIALOG_DATA) public data: DialogData
            , private toastr: ToastrService
            , private familleService: FamilleService) {
             }

    ngOnInit(): void {
      this.form = this.data.form;
    }

    onModalCancel(): void {
      this.data.result = false;
      this.dialogRef.close(false);
    }

    onModalConfirm(): void {
      if (this.form.valid) {
        const famille = this.form.getRawValue();
        // Création
        if (!this.form.get('id').value){
          const dialogRef = this.dialog.open(SpinnerModalComponent);
            this.familleService.save(famille).subscribe((a: FamilleModel) => {
              this.toastr.success('', 'Création de la famille ' + a.code + ' réussie');
              this.dialogRef.close(a);
              dialogRef.close();
            }, (error) => {
              this.dialogRef.close(false);
              dialogRef.close();
            });
        }else { // Modification
          const dialogRef = this.dialog.open(SpinnerModalComponent);
          this.familleService.update(famille.id, famille).subscribe((a: FamilleModel) => {
            this.toastr.success('', 'Modification de la famille ' + a.code + ' réussie');
            this.dialogRef.close(a);
            dialogRef.close();
          }, (error) => {
            this.dialogRef.close(false);
            dialogRef.close();
          });
        }
      } else {
        this.displayErrors();
      }
   }

   displayErrors(): void {
    for (const index in this.form.controls) {
      if (index && (this.form.controls[index].hasError('required') || this.form.controls[index].hasError('max'))) {
        this.form.controls[index].markAsTouched();
      }
    }
  }
}




